"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfirmDialog = void 0;
var tslib_1 = require("tslib");
// (C) 2020 GoodData Corporation
var react_1 = tslib_1.__importStar(require("react"));
var Overlay_1 = require("../Overlay");
var ConfirmDialogBase_1 = require("./ConfirmDialogBase");
/**
 * @internal
 */
var ConfirmDialog = /** @class */ (function (_super) {
    tslib_1.__extends(ConfirmDialog, _super);
    function ConfirmDialog() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ConfirmDialog.prototype.render = function () {
        var _a = this.props, containerClassName = _a.containerClassName, dialogProps = tslib_1.__rest(_a, ["containerClassName"]);
        return (react_1.default.createElement(Overlay_1.Overlay, { alignPoints: [
                {
                    align: "cc cc",
                },
            ], isModal: true, positionType: "fixed", containerClassName: containerClassName },
            react_1.default.createElement(ConfirmDialogBase_1.ConfirmDialogBase, tslib_1.__assign({}, dialogProps))));
    };
    return ConfirmDialog;
}(react_1.PureComponent));
exports.ConfirmDialog = ConfirmDialog;
//# sourceMappingURL=ConfirmDialog.js.map